import React, { Component, useEffect, useState } from 'react';
import central, { FormatoDataHora } from '../api/Central';
import Resultado from '../api/Resultado.js';
import Alert from '../components/Alert.js';
import Error from '../components/Error.js';
import Navegacao from '../components/Navegacao.js';

const Acesso = ({ item }) => {
  return (<React.Fragment>
    <tr>
      <td>{FormatoDataHora.format(item.datainicio)}</td>
      <td>{FormatoDataHora.format(item.datafim)}</td>
      <td>{item.bytesenviados}</td>
      <td>{item.bytesrecebidos}</td>
    </tr>
  </React.Fragment>)
};

const anos = [
  new Date().getFullYear() - 1,
  new Date().getFullYear(),
]
const meses = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

const TabelaAcessos = ({ mes, ano, idconta }) => {
  const [acessos, setAcessos] = useState([]);
  const [erro, setErro] = useState();
  const [carregando, setCarregando] = useState();

  const carrega = React.useCallback(() => {
    setCarregando(true);

    central.requestAndCatch(
      "GET",
      "/acessos?conta=" + idconta
      + "&ano=" + ano
      + "&mes=" + mes,
      null,
      (payload) => {
        setErro(undefined);
        var res = new Resultado(payload);
        setAcessos(res.rows);
      },
      (msg) => {
        setErro("Erro ao consultar acessos: " + msg);
      },
      () => {
        setCarregando(false);
      });

  }, [idconta, ano, mes, setCarregando, setAcessos, setErro]);

  useEffect(carrega, [idconta, ano, mes]);

  return carregando
    ? <Alert type="info">Carregando...</Alert>
    : erro
      ? <Error msg={erro} disabled={carregando} onButtonClick={carrega} buttonLabel="Tentar Novamente" />
      : acessos.length === 0
        ? <Alert type="info">Nenhum acesso encontrado no mês selecionado.</Alert>
        : <table>
          <thead>
            <tr>
              <th>Início</th>
              <th>Fim</th>
              <th>Bytes enviados</th>
              <th>Bytes recebidos</th>
            </tr>
          </thead>
          <tbody>
            {acessos && acessos.map && acessos.map((item) => <Acesso key={item.id} item={item} />)}
          </tbody>
        </table>;
}

class Acessos extends Component {

  constructor(props) {
    super(props);
    this.state = {
      disabled: false,
      erro: null,
      carregado: true,
      ano: new Date().getFullYear(),
      mes: new Date().getMonth() + 1,
      idconta: 0
    }
  }

  redireciona() {
    this.props.history.push("/login");
  }



  componentDidMount() {
  }

  render() {

    return (
      <section className="container">
        <Navegacao link="/" titulo="Meus Acessos" />

        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'baseline',
          maxWidth: 480
        }}>
          <label style={{ flexGrow: 1, marginRight: 10 }}>Serviço:</label>
          <CampoContas onChange={(id) => { this.setState({ idconta: id }); }} idconta={this.state.idconta} />
        </div>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'baseline',
          maxWidth: 480
        }}>
          <label htmlFor='selAno' style={{ flexGrow: 1, marginRight: 10 }}>Ano:</label>
          <select id="selAno" style={{ flexGrow: 4 }} onChange={(ev) => {
            this.setState({ ano: ev.target.value });
          }}>
            {anos.map(m => <option key={m} value={m} selected={m === this.state.ano}>{m}</option>)}
          </select>
          <label htmlFor='selMes' style={{ flexGrow: 1, marginRight: 10, marginLeft: 10 }}>Mês:</label>
          <select id="selMes" style={{ flexGrow: 4, flexShrink: 1 }} onChange={(ev) => {
            this.setState({ mes: ev.target.value })
          }}>
            {meses.map(m => <option key={m} value={m} selected={m === this.state.mes}>{m}</option>)}
          </select>
        </div>
        <section>
          <TabelaAcessos idconta={this.state.idconta} ano={this.state.ano} mes={this.state.mes} />
        </section>
      </section>

    );
  }
}


class CampoContas extends Component {

  constructor(props) {
    super(props);
    this.state = {
      carregando: false,
      erro: null,
      contas: { rows: [] }
    }
  }

  carrega() {
    central.listaContas((resultado) => {
      try {
        this.setState({ contas: resultado });
        this.props.onChange(resultado.rows[0].idconta);
      } catch (err) {
        this.setState({ erro: err });
      }
    },
      (msgErro) => {
        this.setState({ erro: msgErro });
      },
      () => {
        this.setState({ carregando: false });
      }
    );
  }

  componentDidMount() {
    this.carrega();
  }

  render() {

    return (
      <select onChange={(ev) => { this.props.onChange(ev.target.value) }}>
        {this.state.contas.rows.map((item) => <option key={item.idconta} selected={this.props.idconta === item.idconta} value={item.idconta}>
          SERVIÇO {item.idconta} ({item.nome}) - Vencimento dia {item.diavencimento}
        </option>)}
      </select>

    );

  }
}

export default Acessos;